import axios from "axios";
import { app } from "@/app/index.js";

const baseURL = process.env.VUE_APP_API;
const http = axios.create({ baseURL });

http.interceptors.request.use((config) => {
  return config;
});

export const namespace = "authRestorePassword";

export const module = {
  namespaced: true,
  state: {
    pending: false,
    email: "",
  },
  getters: {
    pending: (s) => s.pending,
    email: (s) => s.email,
  },
  mutations: {
    pending(state, value) {
      state.pending = value;
    },
    email(state, value) {
      state.email = value;
    },
  },
  actions: {
    restorePassword({ state, commit }) {
      return new Promise((resolve, reject) => {
        app.$store.commit("errors", {});
        if (!state.pending) {
          commit("pending", true);
          http
            .post("/reset-password-request", {
              email: state.email,
            })
            .then((response) => {
              resolve(response);
              commit("pending", false);
            })
            .catch((error) => {
              reject(error);
              commit("pending", false);
            });
        } else {
          commit("pending", false);
          resolve(true);
        }
      });
    },
  },
};
